import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {RecoilRoot} from 'recoil';
import {HeroUIProvider} from "@heroui/react";
import {RouterProvider} from 'react-router-dom';
import routes from './routes.jsx';
import {MantineProvider} from '@mantine/core';
import {Toaster} from 'react-hot-toast';
import * as Sentry from '@sentry/react';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 0,
			refetchOnWindowFocus: false
		},
		mutations: {
			retry: 0,
			refetchOnWindowFocus: false
		}
	}
});

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DNS,
	enabled: false,
	integrations: [],
});


export default function App() {
	return (
		<RecoilRoot>
			<QueryClientProvider client={queryClient}>
				<MantineProvider>
					<HeroUIProvider>
						<Toaster
							position="top-center"
							toastOptions={{
								duration: 3500,
								style: {
									borderRadius: '9999px',
									background: 'linear-gradient(120deg, #2a0a6e 0%, #1b0740 100%)',
									color: '#fff',
									padding: '10px 18px',
									fontSize: '14px',
									fontWeight: 500,
									lineHeight: '1.35',
									wordBreak: 'break-word',
									maxWidth: '460px',
									border: '1px solid rgba(255,255,255,0.10)',
									boxShadow: '0 18px 40px -18px rgba(90,10,224,0.55)',
								},
								success: {iconTheme: {primary: '#a855f7', secondary: '#fff'}},
								error: {iconTheme: {primary: '#f43f5e', secondary: '#fff'}},
							}}/>
						<RouterProvider router={routes}/>
					</HeroUIProvider>
				</MantineProvider>
			</QueryClientProvider>
		</RecoilRoot>
	)
}
